import { useState } from 'react';

import styled from 'styled-components';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';

import { Loading } from 'components/Loading';
import { Modal } from 'features/modals';
import { useStore } from 'models/Provider';

export default function CustomConfirmModal({
  confirm,
  data,
  closeModal,
  onCancel,
  danger,
  isHtml = false,
}) {
  const { t } = useStore();
  const [submitting, setSubmitting] = useState(false);

  function cancel() {
    if (onCancel) {
      onCancel();
    }
    closeModal();
  }

  async function submit() {
    setSubmitting(true);
    const success = await confirm(data.id);
    setSubmitting(false);
    if (success) {
      closeModal();
    }
  }
  return (
    <Modal>
      <Modal.Header text={t('modals.confirm.title')} />
      {submitting && <Loading />}
      <Stack space={4}>
        {isHtml ? <StyledHtmlContent>{data.text}</StyledHtmlContent> : <Text text={data.text} />}

        <Text color="red100" font="bold16" text={t('modals.confirm.warning')} />
      </Stack>
      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={!submitting ? cancel : null}
          isDisabled={submitting}
          text={t('modals.confirm.button.cancel')}
        />
        <Button
          variant={danger ? 'primary-red' : 'primary'}
          onClick={!submitting ? submit : null}
          isDisabled={submitting}
          text={t('modals.confirm.button.submit')}
        />
      </Modal.Actions>
    </Modal>
  );
}

const StyledHtmlContent = styled.div({
  color: theme.color.purple100,
});
